import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1e62819e = () => interopDefault(import('../src/pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _a4c8c1f4 = () => interopDefault(import('../src/pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _1bb8d387 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5e32d652 = () => interopDefault(import('../src/pages/news/_detail/index.vue' /* webpackChunkName: "pages/news/_detail/index" */))
const _642a4cda = () => interopDefault(import('@/pages/index.vue' /* webpackChunkName: "" */))
const _4f0321be = () => interopDefault(import('@/pages/news/index.vue' /* webpackChunkName: "" */))
const _24965bdf = () => interopDefault(import('@/pages/news/_detail/index.vue' /* webpackChunkName: "" */))
const _50419253 = () => interopDefault(import('@/pages/search/index.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/news",
    component: _1e62819e,
    name: "news"
  }, {
    path: "/search",
    component: _a4c8c1f4,
    name: "search"
  }, {
    path: "/",
    component: _1bb8d387,
    name: "index"
  }, {
    path: "/news/:detail",
    component: _5e32d652,
    name: "news-detail"
  }, {
    path: "*",
    component: _642a4cda
  }, {
    path: "/news",
    component: _4f0321be
  }, {
    path: "/news/detail/:detail",
    component: _24965bdf
  }, {
    path: "/search",
    component: _50419253
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
